import GetQuoteComponent from "../components/Quotes/GetQuoteComponent";
import Homepage from "../components/Homepage";
import Success from "../components/Quotes/Success";
import NotFound from "../components/Error/NotFound";
import Login from "../components/Login";
import Dashboard from "../components/User/Dashboard";
import Reset from "../components/User/Reset";
import Forgot from "../components/User/Forgot";
import Privacy from "../components/Static/Privacy";
import Terms from "../components/Static/Terms";
import Contact from "../components/Static/Contact";
import Faq from "../components/Static/Faq";
import beforEach from "./beforEach";

const routes = [
  {
    path: "/home",
    component: Homepage,
    name: "homepage",
    meta: {}
  },
  {
    path: "/login",
    component: Login,
    name: "login",
    meta: {}
  },
  {
    path: "/get-quote",
    component: GetQuoteComponent,
    name: "get-quote",
    meta: {}
  },
  {
    path: "/success",
    component: Success,
    name: "success",
    meta: {}
  },
  {
    path: "/404",
    alias: "*",
    name: "404",
    component: NotFound
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard
  },
  {
    path: "/reset-password/:token",
    name: "reset",
    component: Reset
  },
  {
    path: "/forgot-password",
    name: "forgot",
    component: Forgot
  },
  {
    path: "/privacy",
    name: "privacy",
    component: Privacy
  },
  {
    path: "/terms",
    name: "terms",
    component: Terms
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact
  },
  {
    path: "/faq",
    name: "faq",
    component: Faq
  }
];

export { routes, beforEach }